import { useQuery } from '@tanstack/react-query';

import { campaignsService, FetchAnnouncementsResponse } from '@aslanpay/portal-common-lib';

const useFetchCampaignAnnouncements = (campaignId: string | undefined, enabled = true) => {
  return useQuery<FetchAnnouncementsResponse, Error>(
    ['fetchCampaignAnnouncements', campaignId],
    () => campaignsService.fetchCampaignAnnouncements(campaignId as string, { page: 0, size: 100 }),
    { enabled: enabled && !!campaignId }
  );
};

export default useFetchCampaignAnnouncements;
